import { P as ProductColorAttributeCode } from './product-_pRduMz7.js';

const colorCodesList = [
    ProductColorAttributeCode.Color,
    ProductColorAttributeCode.ColorLinen,
    ProductColorAttributeCode.ColorHeadboard,
    ProductColorAttributeCode.ColorClothes,
    ProductColorAttributeCode.ColorClothe,
    ProductColorAttributeCode.ColorBed,
];

export { colorCodesList as c };
//# sourceMappingURL=constants-LkG-Sonv.js.map
